/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown>, message: NonNullable<unknown> }} Mobile_Unhandled_Social_ErrorInputs */

const en_mobile_unhandled_social_error = /** @type {(inputs: Mobile_Unhandled_Social_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.provider} (unhandled): ${i?.message}`)
};

const es_mobile_unhandled_social_error = /** @type {(inputs: Mobile_Unhandled_Social_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.provider} (sin manejar): ${i?.message}`)
};

/**
* | output |
* | --- |
* | "{provider} (unhandled): {message}" |
*
* @param {Mobile_Unhandled_Social_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_unhandled_social_error = /** @type {((inputs: Mobile_Unhandled_Social_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Unhandled_Social_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_unhandled_social_error(inputs)
	return en_mobile_unhandled_social_error(inputs)
});